// removed by extract-text-webpack-plugin
module.exports = {"heatmap-fragment":"styles__heatmap-fragment___1sPBb","heatmap-container":"styles__heatmap-container___3DcPZ","heatmap-text":"styles__heatmap-text___1xSeg","heatmap-color":"styles__heatmap-color___3QypC","component-title":"styles__component-title___2wgLU","component-wrapper":"styles__component-wrapper___MmQBm","tooltip":"styles__tooltip___3dQ-5","tooltiptext":"styles__tooltiptext___3SHIE"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ReportComponents/HeatMaps/HourlyFailureHeatMap/styles.scss
// module id = 7065
// module chunks = 0